import styled from "@emotion/styled";
import {NavLink} from "react-router-dom";

export const Sidebar = styled.aside`
    --left-nav-width: 229px;
    background-color: var(--background-content);
    flex-shrink: 0;
    box-shadow: -1px 0 0 0 var(--border-drop-shadow) inset;
    padding-right: 1px;
    overflow: hidden auto;
    height: 100%;
    align-self: stretch;
`;

export const NavColumn = styled.nav`
    display: flex;
    flex-direction: column;
    width: 228px;
    min-height: 100%;
    background-color: var(--shell-main-nav-bg-v2);
`;

export const NavLabel = styled.div`
    padding: 16px 24px;
    margin-bottom: 8px;
    box-shadow: 0 -1px 0 0 var(--border-drop-shadow) inset;
    font-weight: 590;
    line-height: 24px;
    font-size: 14px;
    color: var(--text-primary);
`;

const navLinkBaseStyles = `
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 4px;
    border-left: 8px solid transparent;
    color: var(--text-primary);
    font-size: 14px;
    line-height: 24px;
    text-decoration: none;
    box-sizing: border-box;

    &:hover {
        background-color: var(--shell-main-nav-bg-hover-v2);
    }
`;

const navLinkActiveStyles = `
    &.active {
        background-color: var(--background-hover);
        border-left-color: var(--shell-main-nav-icon-text-selected-v2);
        color: var(--shell-main-nav-icon-text-selected-v2);
    }
`;

const navLinkGroupActiveStyles = `
    &.active {
        background-color: var(--background-hover);
        color: var(--shell-main-nav-icon-text-selected-v2);
        font-weight: 590;
    }
`;

export const NavLinkItem = styled(NavLink)`
    padding: 16px 40px 16px 16px;
    width: 100%;
    font-weight: 590;
    ${navLinkBaseStyles}
    ${navLinkActiveStyles}
`;

export const NavLinkGroupItem = styled(NavLink)`
    padding: 16px 40px 16px 32px;
    width: 100%;
    font-weight: 400;
    ${navLinkBaseStyles}
    ${navLinkGroupActiveStyles}
`;

export const NavGroup = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const NavGroupHeader = styled.button<{isActive?: boolean}>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    width: 100%;
    box-sizing: border-box;
    padding: 16px 16px 16px 16px;
    border: none;
    border-left: 8px solid ${({isActive}) => isActive ? "var(--shell-main-nav-icon-text-selected-v2)" : "transparent"};
    background-color: ${({isActive}) => isActive ? "var(--background-hover)" : "transparent"};
    color: ${({isActive}) => isActive ? "var(--shell-main-nav-icon-text-selected-v2)" : "var(--text-primary)"};
    --icon-primary: currentColor;
    font-size: 14px;
    font-weight: 590;
    line-height: 24px;
    cursor: pointer;
    text-align: left;

    &:hover {
        background-color: var(--shell-main-nav-bg-hover-v2);
    }
`;

export const NavGroupHeaderLabel = styled.span`
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const NavGroupChildren = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    > * {
        font-weight: 400;
    }
    
`;
